import * as t from "react";
import { forwardRef as o } from "react";
const a = o(function(e, r) {
  return /* @__PURE__ */ t.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ t.createElement("rect", { fill: "#fff", height: 24, rx: 12, width: 24 }),
    /* @__PURE__ */ t.createElement(
      "path",
      {
        d: "M6.78711 13.0312L10.5059 16.75L17.4121 7.71875",
        stroke: "#089B80",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2
      }
    )
  );
});
export {
  a as StatusIconCashOut
};
